import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcPlayFillWhiteshadow(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    fillRule: "evenodd",
    clipPath: "url(#a)",
    clipRule: "evenodd",
    filter: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 17.337c0 1.582 1.75 2.538 3.082 1.682l8.301-5.336a2 2 0 0 0 0-3.365L9.082 4.981C7.75 4.126 6 5.081 6 6.664z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.25 6.664c0-2.176 2.407-3.49 4.237-2.314l8.302 5.337c1.683 1.083 1.683 3.544 0 4.627L9.487 19.65c-1.83 1.177-4.237-.137-4.237-2.313zm3.426-1.052A1.25 1.25 0 0 0 6.75 6.664v10.673a1.25 1.25 0 0 0 1.926 1.052l8.301-5.337a1.25 1.25 0 0 0 0-2.103z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    width: 19.802,
    height: 22.182,
    x: 2.25,
    y: 2.909,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_22736_28211"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_22736_28211",
    result: "effect2_dropShadow_22736_28211"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_22736_28211",
    result: "shape"
  }))));
}
var IcPlayFillWhiteshadow = createNolIcon(/*#__PURE__*/forwardRef(SvgIcPlayFillWhiteshadow));

export { IcPlayFillWhiteshadow as I };
